import api from 'api';
import { logAndCaptureException } from 'utils';
import { ColumnService } from 'lib/services/directory';
import { LaunchDarklyFlags } from 'lib/types/launchDarklyFlags';
import { getCloudConvertOnCallFn } from './callableFunctions';
import { getBooleanFlag } from './flags';

const convertFile = getCloudConvertOnCallFn();

export type CloudConvertOptions = {
  pages_fit_wide?: number;
};

export const cloudConvertFile = async (
  storageId: string,
  input: string,
  output: string,
  opts: CloudConvertOptions = {}
) => {
  const params = { storageId, input, output, opts };
  const useCloudRunCloudConvert = getBooleanFlag(
    LaunchDarklyFlags.USE_CLOUD_RUN_CLOUD_CONVERT,
    false
  );

  let convertedUrl: string;
  if (useCloudRunCloudConvert) {
    const { error, response } = await api.safePost<'documents/cloud-convert'>(
      'documents/cloud-convert',
      params
    );
    if (error) {
      logAndCaptureException(
        ColumnService.FILE_TRANSFORMATION,
        error,
        'Error converting file',
        {
          storageId,
          input,
          output
        }
      );
      throw new Error(error);
    }
    convertedUrl = response ?? '';
  } else {
    const result = await convertFile(params);
    convertedUrl = result.data;
  }

  const data = (await fetch(convertedUrl)).arrayBuffer();
  return data;
};
